import React from 'react';
import PropTypes from 'prop-types';
import { DataDisplayTable } from 'components/data-display';
import { buildFieldValue } from 'pages/employee-reviews/shared';

const defaultArray = [];

// Renders v1 of a topic's snapshot envelope. The envelope is self-describing: the labels and
// typed values frozen at completion are part of the point-in-time record, so the display is
// driven entirely by the captured fields and is the same for every topic that emits one.
//
// leadingFields are the caller's own fields, shown above the captured ones in the same table so
// the whole topic keeps a single spacing rhythm. displayInRows lays the fields out one per row, as a
// striped label and value table, rather than in columns.
export function TopicSnapshot(
    {
        data = null,
        loading = false,
        leadingFields = defaultArray,
        displayInRows = false
    }
) {

    const capturedFields = (data?.fields ?? []).map((field) => {
        return {
            key: field.key,
            header: field.label,
            value: buildFieldValue(field)
        };
    });

    return (
        <DataDisplayTable data={[...leadingFields, ...capturedFields]} displayInRows={displayInRows} loading={loading} />
    );
}

TopicSnapshot.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    leadingFields: PropTypes.array,
    displayInRows: PropTypes.bool
};
